import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPublicCmsData } from "../api/cmsApi";
import { listBlogCategories, listBlogs } from "../data/cmsStore";

const base = process.env.PUBLIC_URL || "";

export default function BlogPage() {
  const [blogs, setBlogs] = useState(() => listBlogs().filter((b) => b.status === "published"));
  const [categories, setCategories] = useState(() => listBlogCategories());
  useEffect(() => {
    (async () => {
      try {
        const data = await fetchPublicCmsData();
        if (Array.isArray(data.blogs) && data.blogs.length) {
          setBlogs(data.blogs.filter((b) => b.status === "published"));
        }
        if (Array.isArray(data.blogCategories) && data.blogCategories.length) {
          setCategories(data.blogCategories);
        }
      } catch (_) {
        // Keep local fallback data if API is unreachable.
      }
    })();
  }, []);
  const catName = (id) => categories.find((c) => c.id === id)?.name || "";

  return (
    <div className="cms-public-page">
      <section className="cms-hero animate-on-scroll">
        <div className="container">
          <span className="cms-label">Insights</span>
          <h1>Emicron Blog</h1>
          <p>Cloud, cybersecurity, and IT delivery insights from our team.</p>
        </div>
      </section>
      <section className="cms-section animate-on-scroll">
        <div className="container">
          <div className="cms-card-grid">
            {blogs.map((blog) => (
              <article key={blog.id} className="cms-card">
                <Link to={`/blog/${blog.slug}`} className="cms-card-media">
                  <img src={`${base}${blog.image}`} alt={blog.title} loading="lazy" />
                </Link>
                <div className="cms-card-body">
                  <span className="cms-chip">{catName(blog.categoryId)}</span>
                  <h2><Link to={`/blog/${blog.slug}`}>{blog.title}</Link></h2>
                  <p>{blog.excerpt}</p>
                  <div className="cms-meta">{blog.author} · {blog.publishedAt}</div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
